import { HStack, VStack } from '@sgme/ui';
import { FormattedMessage } from 'react-intl';

export function Priceable() {
  return (
    <HStack data-e2e="rates" fullWidth className="">
      <div className="w-50 border-end text-center bg-lvl2" style={{ height: 100 }}>
        <VStack
          horizontalAlignment="center"
          verticalAlignment="center"
          fullWidth
          fullHeight
          className="fw-semibold text-secondary bg-lvl2"
          data-e2e="fill-in-bid-price"
        >
          <FormattedMessage id="streaming.reprice.bid.price" values={{ br: <br /> }} />
        </VStack>
      </div>
      <div className="w-50 text-center bg-lvl2" style={{ height: 100 }}>
        <VStack
          horizontalAlignment="center"
          verticalAlignment="center"
          fullWidth
          fullHeight
          className="fw-semibold text-secondary bg-lvl2"
          data-e2e="fill-in-ask-price"
        >
          <FormattedMessage id="streaming.reprice.ask.price" values={{ br: <br /> }} />
        </VStack>
      </div>
    </HStack>
  );
}

